import React from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Screenshots from './components/Screenshots';
import Roster from './components/Roster';
import Events from './components/Events';
import Join from './components/Join';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
        <Header />
        <main>
          <Hero />
          <About />
          <Screenshots />
          <Roster />
          <Events />
          <Join />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;